
import {
  Component,
  Getter,
  Prop,
  State,
  Vue,
  Watch,
} from 'nuxt-property-decorator';
import FilmSkeletonLoader from './FilmSkeletonLoader.vue';
import FilmHero from './FilmHero.vue';
import FilmOverview from './FilmOverview.vue';
import FilmInfoTabs from './FilmInfoTabs.vue';
import SanityDocument from '~/components/Sanity/SanityDocument.vue';
import MoreFilmsCarousel from './MoreFilmsCarousel.vue';
import {
  SanityDocumentSchema,
  ISanityDocuments,
} from '~/types/sanity-documents';

@Component({
  components: {
    SanityDocument,
    FilmHero,
    FilmOverview,
    FilmInfoTabs,
    FilmSkeletonLoader,
    MoreFilmsCarousel,
  },
})
export default class FilmAboutPage extends Vue {
  @Prop(Boolean) readonly loading!: boolean;
  @Prop(Object) readonly doc!: ISanityDocuments[SanityDocumentSchema.FILM];

  schemas = SanityDocumentSchema;

  @Watch('doc', { immediate: true })
  handleDocChange(
    current: ISanityDocuments[SanityDocumentSchema.FILM] | undefined,
    previous: ISanityDocuments[SanityDocumentSchema.FILM] | undefined,
  ) {
    if (!current) {
      return;
    }

    const docRefs = this.$sanityLookup.getDocumentRefIds(current);
    if (docRefs) {
      this.$sanityLookup.fetchReference({
        _id: Object.keys(docRefs).filter(
          (id) =>
            !!docRefs[id] &&
            id !== current?.content?._ref &&
            id !== current?.uaPage?._ref,
        ),
      });
    }
  }

  @Watch('mainContentRef', { immediate: true })
  handleDocContentChange(
    current: string | undefined,
    previous: string | undefined,
  ) {
    if (current === previous) {
      return;
    }

    const contentRefState = this.$sanityLookup.getDocumentFromReference({
      _ref: current,
    });
    if (!contentRefState?.isLoading && !contentRefState?.data) {
      this.$sanityLookup.fetchReference({
        _id: current,
        _type: this.schemas.VIDEO,
        fetchReferences: true,
      });
    }
  }

  get mainContentRef() {
    return this.doc?.content?._ref;
  }

  get mainContentState() {
    return this.mainContentRef
      ? this.$sanityLookup.getDocumentFromReference({
          _ref: this.mainContentRef,
        })
      : { isLoading: false, hasError: false };
  }
}
